import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './styles/globals.css';

const STALE_CHUNK_KEY = 'dbscaffolding:stale-chunk-reload';
const isStaleChunkError = (e: unknown) => {
  const msg = e instanceof Error ? e.message : String(e);
  return (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Unexpected token')
  );
};

const reloadOnce = () => {
  if (sessionStorage.getItem(STALE_CHUNK_KEY)) return;
  sessionStorage.setItem(STALE_CHUNK_KEY, '1');
  window.location.reload();
};

window.addEventListener('error', (event) => {
  if (isStaleChunkError(event.error ?? event.message)) reloadOnce();
});

window.addEventListener('unhandledrejection', (event) => {
  if (isStaleChunkError(event.reason)) reloadOnce();
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
